import { render } from "./OnPremiseReport.vue?vue&type=template&id=94567028&scoped=true"
import script from "./OnPremiseReport.js?vue&type=script&lang=js"
export * from "./OnPremiseReport.js?vue&type=script&lang=js"

import "./OnPremiseReport.scss?vue&type=style&index=0&id=94567028&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94567028"]])

export default __exports__